import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b8f62fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-title"
};
const _hoisted_2 = {
  class: "card-detail text-sec-info"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail-title"
}, "订单号：", -1));
const _hoisted_4 = {
  class: "detail-info"
};
const _hoisted_5 = {
  class: "card-detail text-sec-info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail-title"
}, "更新时间：", -1));
const _hoisted_7 = {
  class: "detail-info"
};
const _hoisted_8 = {
  class: "action-wrap"
};
import { computed, inject } from 'vue';
import { PlainButton, CellCard } from '@/components';
import { useOrderConfig } from './useOrderConfig';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
    data: null
  },
  setup(__props) {
    const props = __props;
    const reloadList = inject('reloadList');
    const {
      orderConfigMap
    } = useOrderConfig({
      reloadList
    });
    const cardConfig = computed(() => {
      return orderConfigMap[props.data.status] || {};
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(CellCard), {
        class: "order-card"
      }, _createSlots({
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(props.data.productName), 1), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(props.data.orderNo), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(props.data.updateTime), 1)]), _createElementVNode("div", {
          class: _normalizeClass(["card-status", _unref(cardConfig).nameClass])
        }, _toDisplayString(_unref(cardConfig).statusName), 3)]),
        _: 2
      }, [_unref(cardConfig).actions ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardConfig).actions, buttonConfig => {
          return _openBlock(), _createBlock(_unref(PlainButton), {
            key: buttonConfig.label,
            type: buttonConfig.type,
            onClick: $event => buttonConfig.onClick(props.data.orderNo, props.data.status),
            class: "action-button"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(buttonConfig.label), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))])]),
        key: "0"
      } : undefined]), 1024);
    };
  }
});